export default "__VITE_ASSET__ywcstMWA__"